import {LayoutComponent} from "../../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {SpajkRiplayBsiComponent} from "./spajk-riplay-bsi.component";

const routes: Routes = [
  {
    path: 'spajk-riplay-bsi',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: SpajkRiplayBsiComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SpajkRiplayBsiRoutingModule { }
